import classes from "./Section2.module.css";

export default function Section2() {
  return (
    <div className={classes.section2Wrapper}>
      <div className={classes.section2Container}>
        <div className={classes.section2Image}>
          <img src="/img/about-img/about-img-1.jpg" alt="about-us" />
        </div>
        <div className={classes.section2Content}>
          <h2>
            OUR <span>VISION:</span>
          </h2>
          <p>
            Optimize your business with the technology of today! Server Stock is
            committed to creating a dependable platform that caters to all your
            hardware needs, ranging from intricate machines to essential yet
            long-lasting accessories. Our team of dedicated and passionate
            professionals has built an adaptable online store that addresses
            your IT and computer hardware requirements. We prioritize security
            and confidence in our online marketplace to meet your computer
            hardware needs. At Server Stock, we offer authentic products from
            renowned names in the IT and computer hardware industries, such as
            Dell, HP, Cisco, Lenovo, D-Link, etc.
          </p>
        </div>
      </div>

      <div className={classes.section3Container}>
        <div className={classes.section2Content}>
          <h2>
            TOP <span>NOTCH</span> TECHNOLOGY:
          </h2>

          <p>
            We offer printers, scanners, and servers from the world's leading
            manufacturers, so making the right choice is easy. Our products are
            tailored to budget-conscious customers, providing great value for
            their money. We ensure that you receive your products in the best
            possible condition and within the shortest possible time. Our aim is
            to prioritize your convenience. We make it easy with our branded
            modules if you need to upgrade your existing systems or devices.
            Replacing appliances can disrupt your network, which is why we
            provide simple-to-set-up and install technical modules that are
            always up-to-date. This ensures that your business continues to
            operate smoothly without any downtime. At Server Stock, we provide
            various computer equipment, including power supplies, cables,
            modules, racks, and cabinets, to fulfill your computing needs.
            Moreover, we offer genuine and authorized computer software, from
            Windows to sophisticated server applications, software licenses, and
            anything else you may need. We take our commitments very seriously
            and strive to fulfill your requirements to the best of our ability.
          </p>
        </div>
        <div className={classes.section2Image}>
          <img src="/img/about-img/about-img-2.jpg" alt="about-us" />
        </div>
      </div>

      <div className={classes.section2Container}>
        <div className={classes.section2Image}>
          <img src="/img/about-img/about-img-3.jpg" alt="about-us" />
        </div>
        <div className={classes.section2Content}>
          <h2>
            WHY <span>SERVER STOCK?</span>
          </h2>
          <p>
            Server Stock is a computer and computer hardware reseller and
            supplier based in the United Kingdom. Our organization is a pioneer
            in delivering high-quality products from well-known brands right to
            your doorstep. We are the leading provider of cutting-edge
            technologies, including storage devices, computer memory,
            motherboards, printers, scanners, power supplies, CPUs, servers, and
            network devices. We aim to ensure that our customers are delighted
            with their purchase. We can help you upgrade your PC to meet gaming
            needs or increase corporate efficiency. Our hardware is versatile
            and suitable for both large networks and individuals seeking general
            use. We warmly welcome you, whether you are a corporation looking to
            purchase in bulk or an individual seeking to upgrade your hardware.
          </p>
        </div>
      </div>
    </div>
  );
}
